export const checkCondition = (entry, job_data, internal) => {
    for (var key of Object.keys(entry.Conditions)) {
        if (!checkSpecialConditions(key, entry.Conditions[key], job_data, internal)) return false;
    }
    return true;
};

const checkSpecialConditions = (key, condition, job_data, internal) => {
    if (key.includes("AnyItem")) {
        const items =
            job_data?.QuoteParameters?.BOM?.OrderList?.items ??
            job_data?.QuoteParameters?.BOM?.SystemList?.items;
        if (items) {
            for (var k of Object.keys(items)) {
                if (allConditionTypes(items[k].Code, condition)) return true;
            }
        }
    }

    if (key === "Internal") {
        return internal != null && parseInt(internal) >= parseInt(condition);
    }

    if (key.includes("|")) {
        return key.split("|").some((k) => keyConditions(k, job_data, condition));
    }

    return keyConditions(key, job_data, condition);
};

const checkAttachments = (key, job_data, condition) => {
    let attachments = [];
    for (let index in job_data?.AreaSpecifications) {
        let areaIndex = Number(index);
        let current_area = job_data?.AreaSpecifications[areaIndex];
        let totalAttachments =
            current_area["ATTACHMENTS"]["AttachmentBottom"] +
            current_area["ATTACHMENTS"]["AttachmentLeft"] +
            current_area["ATTACHMENTS"]["AttachmentRight"] +
            current_area["ATTACHMENTS"]["AttachmentTop"];

        for (let mods in current_area["ATTACHMENTS"]["AttachmentModifications"]) {
            attachments.push({
                attachment:
                    current_area["ATTACHMENTS"]["AttachmentModifications"][mods]["AttachmentType"] ===
                    ("" || null || undefined)
                        ? job_data?.QuoteParameters?.BOM?.QuoteData?.JOB_DATA[key.split(".")[1]]
                        : current_area["ATTACHMENTS"]["AttachmentModifications"][mods]["AttachmentType"],
                subAttachment:
                    current_area["ATTACHMENTS"]["AttachmentModifications"][mods]["AttachmentVariation"] ===
                    ("" || null || undefined)
                        ? current_area["ATTACHMENTS"]["AttachmentModifications"][mods]["AttachmentSubType"]
                        : current_area["ATTACHMENTS"]["AttachmentModifications"][mods]["AttachmentVariation"],
            });
        }

        if (totalAttachments > attachments.length) {
            attachments.push({ attachment: job_data?.QuoteParameters?.BOM?.QuoteData?.JOB_DATA[key.split(".")[1]] });
        }
    }

    for (let attachment in attachments) {
        if (attachments[attachment]?.subAttachment && condition.split("/").length > 1) {
            if (
                allConditionTypes(attachments[attachment]?.attachment, condition.split("/")[0]) &&
                allConditionTypes(attachments[attachment]?.subAttachment, condition.split("/")[1])
            ) {
                return true;
            }
        } else if (allConditionTypes(attachments[attachment]?.attachment, condition.split("/")[0])) {
            return true;
        }
    }

    return false;
};

const keyConditions = (key, job_data, condition) => {
    switch (key.split(".")[0]) {
        case "Area":
        case "AnyArea":
            return (job_data?.QuoteParameters?.BOM?.QuoteData?.AreaSpecifications ?? []).some((area) =>
                allConditionTypes(area[key.split(".")[1]], condition)
            );
        case "Job":
            if (key.split(".")[1] === "AttachmentType") return checkAttachments(key, job_data, condition);
            return allConditionTypes(job_data?.QuoteParameters?.BOM?.QuoteData?.JOB_DATA[key.split(".")[1]], condition);
        case "Item": {
            const items =
                job_data?.QuoteParameters?.BOM?.OrderList?.items ??
                job_data?.QuoteParameters?.BOM?.SystemList?.items;
            return items ? Object.values(items).some((item) => allConditionTypes(item.Code, condition)) : false;
        }
        default:
            return (job_data?.QuoteParameters?.BOM?.QuoteData?.AreaSpecifications ?? []).some((area) =>
                allConditionTypes(area[key], condition)
            );
    }
};

const allConditionTypes = (check, conditions) => {
    if (check === undefined) return conditions === false || (typeof conditions === "string" && conditions.startsWith("!"));
    if (conditions === true) return true;
    if (conditions === false) return false;
    if (typeof conditions !== "string") return false;

    if (conditions.includes("|")) {
        return conditions.split("|").some((val) =>
            val.includes("INCLUDES") ? checkIncludes(val, check) : allConditionTypes(check, val)
        );
    }

    if (conditions.startsWith("!")) {
        const negated = conditions.substring(1);
        return negated === "null" ? check !== "" : check !== negated;
    }

    if (conditions.includes("INCLUDES")) return checkIncludes(conditions, check);

    return check === conditions;
};

const checkIncludes = (val, check) => check?.includes(val.split("INCLUDES(")[1].split(")")[0]) ?? false;

const checkSpecificCondition = (config, searchCondition) =>
    (config?.drawings ?? [])
        .filter((drawing) =>
            Object.keys(searchCondition).every((key) => (drawing?.Conditions ?? {})[key] === searchCondition[key])
        )
        .map((drawing) => drawing?.File);

const parseFiles = (entry) => entry.File.split("|").filter(Boolean);

const shouldInclude = (entry, job_data, internal) =>
    entry.Conditions == null || checkCondition(entry, job_data, internal);

const getDrawings = (job_data, config, internal, specificConditions = null) => {
    if (specificConditions) return checkSpecificCondition(config, specificConditions);
    return (config?.drawings ?? [])
        .filter((entry) => entry?.File && shouldInclude(entry, job_data, internal))
        .flatMap(parseFiles);
};

export const getNoStampFiles = (job_data, config, internal, specificConditions = null) => {
    if (specificConditions) return [];
    return (config?.drawings ?? [])
        .filter((entry) => entry?.File && entry?.NoStamp && shouldInclude(entry, job_data, internal))
        .flatMap(parseFiles);
};

const getDrawingsNames = (job_data, config, internal) =>
    (config?.drawings ?? [])
        .filter((entry) => entry?.File && shouldInclude(entry, job_data, internal))
        .reduce((acc, entry) => {
            acc[entry.Name] = parseFiles(entry);
            return acc;
        }, {});

const Drawings = (job_data, config, setName, internal, specificConditions = null) => {
    if (job_data && config && setName) return getDrawingsNames(job_data, config, internal);
    if (job_data && config) return getDrawings(job_data, config, internal, specificConditions);
    return [];
};

export default Drawings;
